import { useTranslation } from "react-i18next";

import { CreditsIcon } from "../../../../atoms";
import { CTAWidget } from "./CTAWidget";

export const CTACreditPack = () => {
  const { t } = useTranslation();
  return (
    <CTAWidget
      title={t(
        "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileGetCreditPack.title",
      )}
      subtitle={t(
        "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileGetCreditPack.subTitle",
      )}
      buttonText={t(
        "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileGetCreditPack.button",
      )}
      icon={
        <CreditsIcon
          className="absolute -right-7 top-0 z-10 block size-[7.75rem]"
          pathClassName="stroke-secondary-25"
        />
      }
    />
  );
};
